import React, {
  useCallback, useContext, useState
} from 'react';
import { useNavigate } from 'react-router-dom';

import { ModalComponent } from '../../base2';
import { AddressProvider, IdentityContext } from '../../context';
import { useCreate } from '../../hooks';
import { PersonalInfoForm } from '../../pages';
import { ButtonBar } from '../basic-inputs';

import { PersonalInfoDisplay } from './personal-info-display';
import { ScreenHeader } from './screen-header';

interface VerifyPersonalInfoContentsProps {
  resource: string;
  steps: number;
  nextPath: string;
  payload?: Record<string, string>;
  updateEntity?: () => void;
}

export function VerifyPersonalInfoContents({ resource, steps, nextPath, payload, updateEntity }: VerifyPersonalInfoContentsProps) {
  const navigate = useNavigate();
  
  // TODO: update root level person context after will creation
  const { person, update } = useContext(IdentityContext);
  
  const { handleCreate } = useCreate(resource);
  
  const [ showModal, setShowModal ] = useState(false);
  
  const handleClose = useCallback(async () => {
    console.log('updating personal info...');
    await update();
    setShowModal(false);
  }, [ update ]);
  
  const handleSave = useCallback(async () => {
    console.log('updating personal info...');
    await update();
    setShowModal(false);
  }, [ update ]);
  
  const handleBack = useCallback(() => {
    navigate('../verify');
  }, [ navigate ]);
  
  const handleEdit = useCallback(() => {
    setShowModal(true);
  }, []);
  
  const handleNext = useCallback(async () => {
    try {
      // return console.log('handleNext', resource, person.id);
      const newEntity = await handleCreate({
        person_id: person.id,
        ...payload
      });
  
      console.log('New entity created:', resource, newEntity);
  
      if (!newEntity) {
        console.error('Failed to create new entity');
        return;
      }
  
      await updateEntity();
      navigate(nextPath);
    } catch (error) {
      console.error('Error creating new entity:', error);
    }
  }, [ handleCreate, navigate, nextPath, payload, person.id, resource, update ]);
  
  return (
    <div className="verify-personal-info-screen screen">
      <ScreenHeader 
        title="Verify Your Personal Info"
        description="Make sure that everything is correct"
        handleBack={handleBack} 
        steps={steps} 
        step={1} 
      />
  
      <AddressProvider>
        <PersonalInfoDisplay />
      </AddressProvider>
  
      <ButtonBar
        handleSecondary={handleEdit}
        secondaryText="Edit"
        handlePrimary={handleNext}
      />
  
      <ModalComponent 
        closeModal={handleClose}
        provideContainer={false}
        showModal={showModal} 
      >
        <PersonalInfoForm create={false} handleSave={handleSave} />
      </ModalComponent>
    </div>
  );
}